import * as React from 'react';

import { SearchBlockContent } from '../../components/SearchBlockContent';
import { IFullTipSchema } from '../../repositories/text-search/entities/tips/FullTipSchema';
import { ISuggestion } from '../../types/suggestions';
import { SearchBlockSuggestsContainer } from '../SearchBlockSuggestsContainer';
import { SearchTipsContainer } from '../SearchTipsContainer/SearchTipsContainer';

interface IDesktopSearchBlockContentContainerProps {
  tips: IFullTipSchema[];
  suggestions: ISuggestion[];
  query: string;
  isNotFound: boolean;
  isTipsDisabled?: boolean;
  isDesktop?: boolean;
  handleTips(tip: IFullTipSchema): void;
  setLoading?(isLoading: boolean): void;
}

export const DesktopSearchBlockContentContainer: React.FC<IDesktopSearchBlockContentContainerProps> = ({
  tips,
  suggestions,
  query,
  isNotFound,
  isTipsDisabled,
  handleTips,
  setLoading,
}) => {
  return (
    <SearchBlockContent
      searchInput={null}
      tips={
        tips.length === 0 ? null : (
          <SearchTipsContainer tips={tips} onClick={handleTips} desktopStyle={true} isTipsDisabled={isTipsDisabled} />
        )
      }
      suggests={
        <SearchBlockSuggestsContainer
          query={query}
          suggestions={suggestions}
          withNotFoundText={isNotFound}
          setLoading={setLoading}
        />
      }
      isDesktop={true}
    />
  );
};
